export default __webpack_public_path__ + "static/media/68.ff5b2c11.png";